import { PromocodeType } from './type';

export const freemiumPromocodeParameters: {
  type: PromocodeType;
  freePeriod: string;
} = {
  type: PromocodeType.Gift,
  freePeriod: 'P3D',
};
